import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Form } from 'react-bootstrap'
import CheckBoxRadioButtonInput from 'components/ui/forms/field/checkbox-radiobutton/CheckBoxRadioButtonInput'
import MandatoryQuestion from 'components/ui/mandatory-question/MandatoryQuestion'
import { breakLinesFix } from 'helpers/others.helper'
import { sanitizeHtml } from 'helpers/sanitizeHtml'
import * as fromLessonActions from 'store/actions/lessons.action'
import answerLikertCreate from 'api/answers/likerts/Create'
import { QuestionTypeV1 } from 'enum/question-type'
import { useLesson } from 'contexts/LessonContext/index'
import { LikertQuestion } from 'store/states/lessons.state'
import styles from './Likert.module.scss'

interface ILikert {
  data: LikertQuestion
  instanceId: number
  refArray: any
  canEdit: boolean

  lessonIndex: number
  questionIndex: number
}

const Likert: React.FC<ILikert> = ({
  data,
  instanceId,
  refArray,
  canEdit,
  lessonIndex,
  questionIndex,
}) => {
  const dispatch = useDispatch()
  const [questionData, setData] = useState([] as any)
  const [selected, changeSelected] = useState({} as any)

  const { submit } = useLesson()

  useEffect(() => {
    const {
      answer: { questionsLikertLabelId: answerId = '' },
      content,
      name,
      mandatory,
      id,
    } = data
    setData({ content, name, mandatory, id })
    changeSelected(answerId)
  }, [data])

  const handleChange = async (id: number) => {
    if (canEdit) {
      const answerAttributes = {
        blockInstanceId: instanceId,
        questionId: data.id,
      }
      changeSelected(id)
      const answer = await answerLikertCreate({
        questionsLikertLabelId: id,
        answerAttributes,
      })
      dispatch(
        fromLessonActions.Actions.lessonsSurveySetQuestionResponse({
          index: lessonIndex,
          questionIndex,
          value: {
            type: QuestionTypeV1.likert,
            answer: {
              id: answer.id,
              questionsLikertLabelId: answer.questionsLikertLabelId,
              createdAt: answer.createdAt,
              updatedAt: answer.updatedAt,
            },
          },
        })
      )
    }
  }

  return (
    <div className="mb-2" id="likert" ref={refArray}>
      <div
        className={styles.question}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(breakLinesFix(questionData.name)),
        }}
      />
      <Form.Group className={'mt-1 mb-0'}>
        {questionData.content &&
          questionData.content.map(({ id, label }: any) => {
            return (
              <CheckBoxRadioButtonInput
                key={id}
                name={`${questionData.content[0].id}-${id}`}
                value={questionData.id}
                checked={selected === id}
                inline={false}
                type={''}
                label={label}
                onChange={() => handleChange(id)}
                disabled={!canEdit}
                error={''}
              />
            )
          })}
      </Form.Group>
      <div>
        <MandatoryQuestion show={submit && data.mandatory} />
      </div>
    </div>
  )
}

export default Likert
